import { render, staticRenderFns } from "./StepVerify.vue?vue&type=template&id=2474c0be&"
import script from "./StepVerify.vue?vue&type=script&lang=js&"
export * from "./StepVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports